import { useContext, useEffect, useMemo, useCallback } from "react";
import getConfig from "../configs/tableConfig";
import BeelditTableHeaderActions from "@beeldit/core/components/BeelditTableHeaderActions";
import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";
import { t } from "i18next";
import useRemoveAction from "../actions/remove/useRemoveAction";
import useListAction from "../actions/list/useListAction";
import { Card } from "react-bootstrap";
import useDetailsAction from "../actions/details/useDetailsAction";
import { useNavigate } from "react-router-dom";
import { TenantAndCommerceContext } from "@main/contexts/TenantAndCommerceContext";
import useExportAction from "@beeldit/ecommerce/products/actions/export/useExportAction";
import { Barcode } from "@phosphor-icons/react";

function ProductsPage(props: any) {
  const { filters, formDefaultValues } = props;

  const { user } = useContext(AuthContext);

  const navigate = useNavigate();

  const { tenantId, commerceId } = useContext(TenantAndCommerceContext);

  const {
    indexFunction,
    actionTemplate: listActionTemplate,
    setTableConfig,
  } = useListAction(user, filters);

  const { prepareRemoveFunction, actionTemplate: removeActionTemplate } =
    useRemoveAction(indexFunction);

  const { detailsFunction } = useDetailsAction(0, null);

  const initializeFunction = useCallback(() => {
    navigate(`/panel/${tenantId}/${commerceId}/products/new`);
  }, [navigate, tenantId, commerceId]);

  const { exportFunction, actionTemplate: exportActionTemplate } =
    useExportAction(filters);

  /**<newActionsHooks**/

  /**
   * Table configuration definition
   */
  const memoTableConfig = useMemo(
    () =>
      getConfig({
        initializeFunction, // We pass the function to initialize a new element (used in the create button)
        indexFunction, // We pass the function to index the table
        prepareRemoveFunction,
        detailsFunction,
        exportFunction,
        /**newActionsTableConfig**/
      }),
    [
      initializeFunction,
      indexFunction,
      prepareRemoveFunction,
      detailsFunction,
      exportFunction,
    ]
  );

  useEffect(() => {
    setTableConfig(memoTableConfig);
  }, [memoTableConfig, setTableConfig]);

  return (
    <Card>
      <Card.Header>
        <Card.Title>
          <Barcode size={24} /> {t("products")}
        </Card.Title>
        <BeelditTableHeaderActions actions={memoTableConfig.actions} />
      </Card.Header>

      <Card.Body>
        {listActionTemplate}
        {/*{createActionTemplate}*/}
        {/*{editActionTemplate}*/}
        {removeActionTemplate}
        {exportActionTemplate}
        {/* newTemplateActions */}
      </Card.Body>
    </Card>
  );
}

export default ProductsPage;
